// src/components/pricing/Faq.jsx
import React, { useState } from "react";
import { faq as defaultFaq } from "../../dummydata";
import Heading from "../common/heading/Heading";
import "./faq.css";

/**
 * Use:
 * <Faq data={customFaqArray} title="FAQs" subtitle="Page-specific FAQs" />
 * If `data` is not provided, it falls back to `defaultFaq` from dummydata.
 */
const Faq = ({ data, title = "frequently Ask Question", subtitle = "FAQS" }) => {
  const [openIndex, setOpenIndex] = useState(null); // store active index or null
  const [showAll, setShowAll] = useState(false); // store visibility state
  const items = Array.isArray(data) && data.length ? data : defaultFaq;

  const toggle = (index) => setOpenIndex((cur) => (cur === index ? null : index));

  const displayedItems = showAll ? items : items.slice(0, 5);

  return (
    <>
      <Heading subtitle={subtitle} title={title} />
      <section className="faq">
        <div className="containerFaq">
          {displayedItems.map((val, index) => (
            <div className="boxFaq" key={index}>
              <button
                className="accordion"
                onClick={() => toggle(index)}
                aria-expanded={openIndex === index}
                aria-controls={`faq-panel-${index}`}
                id={`faq-accordion-${index}`}
                type="button"
              >
                <h2>{val.title}</h2>
                <span>
                  {openIndex === index ? (
                    <i className="fa fa-chevron-down"></i>
                  ) : (
                    <i className="fa fa-chevron-right"></i>
                  )}
                </span>
              </button>

              {openIndex === index ? (
                <div
                  className="text"
                  id={`faq-panel-${index}`}
                  role="region"
                  aria-labelledby={`faq-accordion-${index}`}
                >
                  <p>{val.desc}</p>
                </div>
              ) : null}
            </div>
          ))}
          {items.length > 5 && (
            <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
              <button 
                onClick={() => setShowAll(!showAll)} 
                style={{ 
                  padding: "10px 25px", 
                  backgroundColor: "#1eb2a6", 
                  color: "#fff", 
                  border: "none", 
                  cursor: "pointer", 
                  borderRadius: "5px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  transition: "background-color 0.3s"
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = "#168B82"}
                onMouseOut={(e) => e.target.style.backgroundColor = "#1eb2a6"}
              >
                {showAll ? "Show Less FAQs" : "More FAQs"}
              </button>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Faq;
